var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21",
    "data-name": "Group 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.014,
    height: 25.014,
    viewBox: "0 0 25.014 25.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M5.863,9.918H3.932A8.6,8.6,0,0,1,20.574,7.57a.977.977,0,0,0,1.833-.678A10.554,10.554,0,0,0,1.956,10.443,3.91,3.91,0,0,0,0,13.826v3.322a3.913,3.913,0,0,0,3.908,3.908H5.863a.977.977,0,0,0,.977-.977V10.895A.977.977,0,0,0,5.863,9.918ZM4.885,19.1H3.908a1.956,1.956,0,0,1-1.954-1.954V13.826a1.956,1.956,0,0,1,1.954-1.954h.977Z",
    fill: "#ff3414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M226.553,203H224.6a.977.977,0,0,0-.977.977v10.211a.978.978,0,0,1-.977.977h-2.98v.031a1.954,1.954,0,1,0,0,1.892v.031h2.98a2.935,2.935,0,0,0,2.931-2.931v-.049h.977a3.913,3.913,0,0,0,3.908-3.908v-3.322A3.913,3.913,0,0,0,226.553,203Zm1.954,7.231a1.956,1.956,0,0,1-1.954,1.954h-.977v-7.231h.977a1.956,1.956,0,0,1,1.954,1.954Z",
    transform: "translate(-205.447 -193.082)",
    fill: "#ff3414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e16a293a71bf66dc0dfad9f433310c95.svg";
export { ForwardRef as ReactComponent };